import { style, classes } from 'typestyle';
import { TEAL_PRIMARY } from 'src/utils/Style/Theme';
import { color } from 'csx';

const disabledColor = color('#c7c7c7').toHexString();

export default {
  container: style({
    width: 500,
    overflowY: 'auto',
  }),
  titleContainer: style({
    width: '100%',
    color: 'white',
    fontSize: '1.5rem',
    backgroundColor: '#00a89b',
    padding: '0.5rem 1rem'
  }),
  subtitleContainer: style({
    width: '90%',
    fontSize: '0.9rem',
  }),
  contentContainer: style({
    padding: '1rem'
  }),
  bodyContainer: style({
    width: '100%',
  }),
  leftBodyContainer: style({
    width: '40%',
    display: 'inline-block',
  }),
  rightBodyContainer: style({
    width: '55%',
    display: 'inline-block',
  }),
  footerContainer: style({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  }),
  titleText: style({
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'rgb(108,108,108)',
  }),
  s5button: style({
    background: TEAL_PRIMARY,
    color: 'white',
    height: 45,
    cursor: 'pointer',
    padding: '1rem',
    margin: '0 10px 2px 0',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: '.9rem',
  }),
  s5buttonCancel: style({
    color: TEAL_PRIMARY,
    height: 45,
    cursor: 'pointer',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: '.8rem',
    fontWeight: 300,
    border: '1px solid #ccc',
  }),
  buttonCancel: style({
    position: 'absolute',
    right: 15,
    top: 5,
    fontWeight: 300,
    cursor: 'pointer',
    color: 'darkgrey',
  }),
  textButton: style({
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 600,
    color: TEAL_PRIMARY,
    fontSize: '0.8rem',
    $nest: {
      '&:hover:disabled': {
        cursor: 'not-allowed',
      },
    },
  }),
  textButtonDisabled: style({
    cursor: 'not-allowed',
    color: disabledColor,
  }),
  disabledButtonContainer: style({
    background: disabledColor,
    color: '#ffffff',
  }),
  autocompleteContainer: style({
    width: 200,
    fontSize: '0.9rem',
    display: 'inline-block'
  }),
  getDisabledTextButtonStyles() {
    return classes(this.textButtonDisabled, this.disabledButtonContainer);
  },
};

export const swatchStyles = style({
  $debugName: 'historyStylePaneSwatches',
  width: '100%',
  $nest: {
    div: {
      border: '1px solid #aca899',
      cursor: 'pointer',
      width: 20,
      height: 20,
      margin: '5px 3px',
      flexShrink: 0,
    },
  },
  whiteSpace: 'nowrap',
});
